import { CommonListQuery } from '../../../redux/api/apiTypes';
import bidApi from '../../../redux/api/BidApi';
import { productApi } from '../../../redux/api/ProductApi';
import { User } from '../../common/types/types';
import { AllBargainProductList, AuctionList, AuctionResponse, AuctionSearch, BargainProductItem, BidBargainProduct, BidderDetail, BidderDetailList, CheckBargainProduct, GroupBargainList, GroupBargainResponse, GroupBargainSearch, Product } from '../types';

export const auctionApi = productApi.injectEndpoints({
    endpoints: (builder) => ({
        getClientAuctionList: builder.query<AuctionList, AuctionSearch>({
            // Chỉ lấy tài sản đã được đăng tải, isPublic = 1
            query: (body) => {
                const { page, size, keyword, ...rest } = body;
                return ({
                    url: `client/search?page=${page}&size=${size}&keyword=${keyword || ""}&properties=modifiedDate&sortBy=DESC`,
                    method: 'POST',
                    body: { ...rest, isPublic: 1 }
                })
            },
            transformResponse: (response: { body: AuctionList }, meta, arg) => {
                return response.body;
            }
        }),
        getClientAuctionItem: builder.query<AuctionResponse, { productId: number, statuteId: number }>({
            query: (query) => query.statuteId ? `client/detail/${query.productId}?statuteId=${query.statuteId}` : `client/detail/${query.productId}`,
            transformResponse: (response: { body: AuctionResponse }, meta, arg) => {
                return response.body;
            }
        })
    })
})

export const auctionBidApi = bidApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchallBargainProduct: builder.query<AllBargainProductList, { productId: number, statuteId: number } & CommonListQuery>({
            query: (body) => ({
                url: `fetchall-bargain-product/${body.productId}?page=${body.page || 0}&size=${body.size || 10}&properties=createdDate&sortBy=DESC`,
                method: 'POST',
                body: { statuteId: body.statuteId }
            }),
            transformResponse: (response: { body: AllBargainProductList }, meta, arg) => {
                return response.body;
            }
        }),
        getBidderList: builder.query<BidderDetailList, { productId: number, statuteId: number, preCostStatus?: number, registerStatus?: number } & CommonListQuery>({
            query: (body) => `bidder-list/${body.productId}?page=${body.page || 0}&size=${body.size || 10}${body.statuteId ? `&statuteId=${body.statuteId}` : ''}&properties=modifiedDate&sortBy=DESC` +
                `${body.preCostStatus ? `&preCostStatus=${body.preCostStatus}` : ''}${body.registerStatus ? `&registerStatus=${body.registerStatus}` : ''}`,
            transformResponse: (response: { body: BidderDetailList }, meta, arg) => {
                return response.body;
            }
        }),
        getCurrentBargainProduct: builder.query<BidderDetail, number>({
            query: (id) => `fetch-bargain-product-current/${id}`,
            transformResponse: (response: { body: BidderDetail }, meta, arg) => {
                return response.body;
            }
        }),
        bidBargainProduct: builder.mutation<BidBargainProduct, BidBargainProduct>({
            query: (body) => ({
                url: `bargain-product`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { body: BidBargainProduct }, meta, arg) => {
                return response.body;
            }
        }),
        acceptBidder: builder.mutation<BidBargainProduct, BidBargainProduct>({
            query: (body) => ({
                url: `accept-bargain`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { body: BidBargainProduct }, meta, arg) => {
                return response.body;
            }
        }),
        withdrawBargainProduct: builder.mutation<BidBargainProduct, BidBargainProduct>({
            query: (body) => ({
                url: `withdraw-bargain-product`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { body: BidBargainProduct }, meta, arg) => {
                return response.body;
            }
        }),
        groupBargainByLevel: builder.query<GroupBargainList, GroupBargainSearch>({
            query: (body) => ({
                url: `group-bargain-by-level/${body.productId}?page=${body.page || 0}&size=${body.size || 10}`,
                method: 'POST',
                body: body.lstLevel
            }),
            transformResponse: (response: { body: GroupBargainList }, meta, arg) => {
                return response.body;
            }
        }),
        checkBargainProduct: builder.query<BargainProductItem[], CheckBargainProduct>({
            query: (body) => ({
                url: `check-bargain-product`,
                method: 'POST',
                body
            }),
            transformResponse: (response: { body: BargainProductItem[] }, meta, arg) => {
                return response.body;
            }
        }),
        refuseBargain: builder.mutation<BidBargainProduct, number>({
            query: (productId) => ({
                url: `refuse-bargain`,
                method: 'POST',
                body: { productId }
            }),
            transformResponse: (response: { body: BidBargainProduct }, meta, arg) => {
                return response.body;
            }
        }),
        getBargainByIndex: builder.mutation<[{ user: User }], { productId: number, index: number }>({
            query: (body) => ({
                url: `get-bargain-by-index/${body.productId}/${body.index}`,
                method: 'POST'
            }),
            transformResponse: (response: { body: [{ user: User }] }, meta, arg) => {
                return response.body;
            }
        }),
        refuseWithdraw: builder.mutation<BidBargainProduct, number>({
            query: (productId) => ({
                url: `refuse-withdraw`,
                method: 'POST',
                body: { productId }
            }),
            transformResponse: (response: { body: BidBargainProduct }, meta, arg) => {
                return response.body;
            }
        }),
    })
})

export const {
    useLazyGetClientAuctionListQuery,
    useLazyGetClientAuctionItemQuery } = auctionApi;

export const {
    useLazyFetchallBargainProductQuery,
    useLazyGetBidderListQuery,
    useLazyGetCurrentBargainProductQuery,
    useBidBargainProductMutation,
    useAcceptBidderMutation,
    useWithdrawBargainProductMutation,
    useLazyGroupBargainByLevelQuery,
    useLazyCheckBargainProductQuery,
    useRefuseBargainMutation,
    useGetBargainByIndexMutation,
    useRefuseWithdrawMutation } = auctionBidApi;
